import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {PaymentTypeDetail} from "./payment-type-detail";

const PaymentTypeDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/paymenttypes');
    }

    return (
        <PaymentTypeDetail id={id} onClose={onClose}/>
    )

});

export default PaymentTypeDetailPage;